/** 목록 화면 기본 페이지 크기 */
export const DEFAULT_PAGE_SIZE = 25;

/** 페이지 크기 선택 옵션 */
export const PAGE_SIZE_OPTIONS = [10, 25, 50, 100] as const;
